import React, { createElement } from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@immediate_media/components';
import { DATA_ISLAND_ID } from './constants';

/**
 * Get a consistent container ID.
 */
export const getContainerId = (componentName) => `static-${componentName}`;

/**
 * Create a themed element.
 */
export const createThemedElement = (Component, props, themeProps) => createElement(
  ThemeProvider,
  themeProps,
  React.createElement(
    Component,
    props,
  ),
);

/**
 * Invoke a callback when the DOM is ready.
 */
export const onDOMReady = (callback) => {
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', callback);
  }
};

/**
 * Hydrate on the client.
 */
export const hydrate = (Component, componentName) => {
  const containerId = getContainerId(componentName);
  const containerEl = document.getElementById(containerId);
  const dataEl = document.getElementById(DATA_ISLAND_ID);

  if (!containerEl) {
    throw new Error(`No container could be found with the ID "${containerId}"`);
  }

  if (!dataEl) {
    throw new Error(`No data island could be found with the ID "${DATA_ISLAND_ID}"`);
  }

  const {
    [componentName]: props,
    theme: themeProps,
  } = JSON.parse(dataEl.innerHTML);

  ReactDOM.hydrate(createThemedElement(Component, props, themeProps), containerEl);
};
